<ng-container *ngIf="template">
	<ng-template
		*ngTemplateOutlet="template; context: { tooltip: tooltip, placement: placement, content: content }"
	></ng-template>
</ng-container>

<ng-container *ngIf="!template">
	<div
		class="customizable-slider-inner-tooltip"
		[attr.title]="tooltip"
		[attr.data-tooltip-placement]="placement"
	>
		{{ content }}
	</div>
</ng-container>
